var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LvContentTabBar001',{attrs:{"height":"","selected-tab-id":_vm.state,"content-tabs":_vm.tabs},on:{"click":function($event){return _vm.$_onClick($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }